// Module
var code = "<div> <div class=\"search-box\"></div> <div class=\"search-results\"></div> <div class=\"field-search-details\"></div> </div> ";
// Exports
export default code;